import { render, staticRenderFns } from "./OnePath.vue?vue&type=template&id=2128f9bc&"
import script from "./OnePath.vue?vue&type=script&lang=js&"
export * from "./OnePath.vue?vue&type=script&lang=js&"
import style0 from "./OnePath.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports